import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          {/* <p style={{ textAlign: "justify" }}>
            Hi Everyone, I am <span className="purple">Pranit Bhandari </span>
            from <span className="purple"> Kathmandu, Nepal.</span>
            <br />
            I am a self-taught Fullstack developer.
            <br />
            I believe the best way to truly learn and master something is by applying it in our daily lives, rather than just taking a course.
            <br />
            <br />
            Apart from coding, some other activities that I love to do!
          </p> */}
          <p style={{ textAlign: 'justify' }}>
              I fell in love with programming and tech at a young age of 14 during the COVID-19 lockdown where I was stuck with my laptop in my room and I sort of figured some cool sutff!
              <br />
              <br />I am fluent in
              <i>
                <b className="purple"> MERN, Python and UI/UX. </b>
              </i>
              <br />
              <br />
              My field of Interest's are building new &nbsp;
              <i>
                <b className="purple">Web Technologies and Products </b> and
                also in areas related to{" "}
                <b className="purple">
                  AI.
                </b>
              </i>
              <br />
              <br />
              Whenever possible, I also apply my passion for developing products
              with <b className="purple">Node.js</b> and
              <i>
                <b className="purple">
                  {" "}
                  Modern Javascript Library and Frameworks
                </b>
              </i>
              &nbsp; like
              <i>
                <b className="purple"> React.js</b>
              </i>
              <br />
              <br />
              Apart from coding, some other activities that I love to do!
            </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Mountain Biking
            </li>
            <li className="about-activity">
              <ImPointRight /> Hiking
            </li>
            <li className="about-activity">
              <ImPointRight /> Travelling
            </li>
            <li className="about-activity">
              <ImPointRight /> Working Out
            </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
            "Chasing perfection is the best way to progress!"{" "}
          </p>
          <footer className="blockquote-footer">Pranit</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
